import { Injectable } from '@angular/core';
import { Repository, FrameContext } from '@farris/devkit';
import { switchMap } from 'rxjs/operators';
import { EMPTY, Observable, Subject, Subscriber } from 'rxjs';
import { of } from 'rxjs/observable/of';
import { FormNotifyService } from './form-notify.service';
import { LanguageService } from './languag.service';


const POSTER = 'iframePoster';
const RECEIVER = 'iframeReceiver';
const REPOSITORY = 'repository';
// window.hashä¸­funcIdçå±æ§å
const FUNC_ID = 'funcId=';
const TAB_ID = 'tabId=';
/**
 * ChangeItemService
 * @scope FrameComponent
 */
@Injectable()
class ChangeItemService {

  public top = top;
  private funcId: string;
  private tabId: string;
  public itemChangePoster = new Subject<any>();
  public itemChangeReceiver = new Subject<any>();
  /**
   * æé å½æ°
   */
  constructor(
    private repository: Repository<any>,
    private frameContext: FrameContext,
    private notifyService: FormNotifyService,
    private languageService: LanguageService
  ) {
  }

  init() {
    this.top['topMap'] = this.top['topMap'] || {};
    this.changeItem = this.changeItem.bind(this);
  }

  setBykey(key: string, value: any) {
    this.top['topMap'] = this.top['topMap'] || {};
    this.top['topMap'][this.tabId] = this.top['topMap'][this.tabId] || {};
    const topObject = this.top['topMap'][this.tabId];
    topObject[key] = value;
  }
  public static dispose(tabId: string) {
    if (top['topMap']) {
      top['topMap'][tabId] = null;
      delete top['topMap'][tabId];
      if (Object.keys(top['topMap']).length < 1) {
        top['topMap'] = null;
      }
    }
  }
  getByKey(key: string) {
    const topObject = this.top['topMap'] && this.top['topMap'][this.tabId] || {};
    return topObject[key];
  }

  // å»ºç«iframeéä¿¡
  setIframePoster() {
    if (this.getByKey[POSTER]) {
      return;
    } else {
      this.setBykey(POSTER, this.itemChangePoster);
    }
  }

  getIframePoster() {
    this.itemChangePoster = this.getByKey(RECEIVER);
    this.setBykey(RECEIVER, this.itemChangeReceiver);
  }

  changeItem(type: string, id: string, parentId: string) {
    // æ ¹æ®æ¯å¦æ¯å¼¹åºå¼å¡çåä¸åçtabId
    const virtualRootFrameContext = this.frameContext.getVirtualRootFrameContext();
    const virtualRootComponent = virtualRootFrameContext.frameComponent;
    const isDialogComponent = virtualRootComponent['isDialogRootComponent'] || false;
    if (isDialogComponent) {
      this.tabId = window.location.hash.split(TAB_ID)[1].slice(0, window.location.hash.split(TAB_ID)[1].indexOf('&'));
    } else {
      this.tabId = parentId;
    }
    this.itemChangeReceiver = this.getByKey(RECEIVER);
    return Observable.create((subscriber: Subscriber<any>) => {
      this.getNextItemByCurrentId(id, type).subscribe((result: any) => {
        subscriber.next(result);
      });
    });
  }

  // å¨liståå§åæ¶è°ç¨ï¼ç¼å­listçrepository
  setRepository() {
    if (window.location.hash.includes(TAB_ID)) {
      this.tabId = window.location.hash.split(TAB_ID)[1].slice(0, window.location.hash.split(TAB_ID)[1].indexOf('&'));
      this.setBykey(REPOSITORY, this.frameContext.repository);
      this.setIframePoster();
      this.getIframePoster();
    }
  }

  // æ ¹æ®ç±»ååidè·åç¸é»çæ°æ®
  getNextItemByCurrentId(currentId: string, type: string) {
    const repository = this.getByKey(REPOSITORY);
    const { pageSize, pageIndex, total } = repository.entityCollection.paginationInfo;
    let currentIdx = null;
    const list = repository.entityCollection.getAllEntities();
    list.find((x: any, idx: string) => {
      if (x.id === currentId) {
        currentIdx = idx;
      }
    });
    // æ²¡æå¨åè¡¨ä¸­æ¾å°æ°æ®ï¼è¿åç©º
    if (currentIdx === null) {
      // æ°å¢åæ¶å½åæ æ°æ®æ¶ç¹ä¸ä¸æ¡ä¸ä¸æ¡
      if (list.length) {
        switch (type) {
          case 'prev':
            return of(list[list.length - 1].id);
            break;
          case 'next':
            this.notifyService.info(this.languageService.changeToLast, { hideTitle: true });
            return EMPTY;
        }
      }
      return of(null);
    }
    let nextIdx = currentIdx;
    switch (type) {
      case 'prev':
        // å½åé¡µç¬¬ä¸æ¡,ä¸éç¬¬ä¸é¡µ,åä¸ä¸é¡µæåä¸æ¡
        if (currentIdx === 0 && pageIndex !== 1) {
          return repository.getEntities([], [], pageSize, pageIndex - 1).pipe(
            switchMap(result => {
              nextIdx = pageSize - 1;
              return of(result[nextIdx].id);
            })
          );
        }
        // ç¬¬ä¸é¡µç¬¬ä¸æ¡ï¼ä»è¿ååææ°æ®
        else if (currentIdx === 0 && pageIndex === 1) {
          this.notifyService.info(this.languageService.changeToFirst, { hideTitle: true });
          return of(list[nextIdx].id);
        }
        // ä¸æ¯ç¬¬ä¸æ¡ï¼è¿åä¸ä¸æ¡
        else {
          nextIdx = currentIdx - 1;
          return of(list[nextIdx].id);
        }
        break;
      case 'next':
        // è¶è¿å½åé¡µ
        if (currentIdx + 1 + 1 > list.length) {
          // ä¸éæåä¸æ¡æ°æ®,åä¸ä¸é¡µç¬¬ä¸æ¡æ°æ®
          if (((pageIndex - 1) * pageSize + currentIdx + 1) < total) {
            return repository.getEntities([], [], pageSize, pageIndex + 1).pipe(switchMap(result => {
              return of(result[0].id);
            }));
          }
          // æåä¸æ¡æ°æ®ï¼ä»è¿ååæ°æ®
          else {
            this.notifyService.info(this.languageService.changeToLast, { hideTitle: true });
            return of(list[nextIdx].id);
          }
        } else {
          nextIdx = currentIdx + 1;
          return of(list[nextIdx].id);
        }
        break;
    }
  }


}

export { ChangeItemService };
